import type { CartUI } from '@libs/common-node';
import { MERGED_CART_LOCAL_STORAGE_KEY as LS_KEY } from '@libs/core';

const parseMergeLSKeyEntry = (LSEntry: string) => {
    let dismissedMergedCartBanners;

    try {
        dismissedMergedCartBanners = JSON.parse(LSEntry);
    } catch (e) {
        console.error('Failed to parse JSON from dismissedMergedCartBanners in Local Storage', e);

        dismissedMergedCartBanners = {};
    }

    return dismissedMergedCartBanners;
};

const showMergedCartBanner = (guestCartId: string | undefined, updatedCart: CartUI) => {
    if (guestCartId && updatedCart?.merged) {
        const dismissedMergedCartLSEntry = localStorage.getItem(LS_KEY);

        if (dismissedMergedCartLSEntry) {
            const dismissedMergedCartBanners = parseMergeLSKeyEntry(dismissedMergedCartLSEntry);

            const bannersClosedStatuses = {
                ...dismissedMergedCartBanners,
                [updatedCart.id]: false,
            };

            localStorage.setItem(LS_KEY, JSON.stringify(bannersClosedStatuses));
        }
    }
};

export { showMergedCartBanner };
